import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var commerceDataAggregatorUrl = function commerceDataAggregatorUrl(baseUrl) {
  return (// check and remove trailing '/' to make sure URL is not malformed
    "".concat(baseUrl.replace(/\/$/, ''), "/checkout/_ajax/commercedataaggregator/v2")
  );
};
export var getCouponData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(itemId, baseUrl, sdkKey) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", fetch(commerceDataAggregatorUrl(baseUrl), {
            credentials: 'include',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CHEGG-CHECKOUTSDK-API-KEY': sdkKey,
              'X-CHEGG-ORIGIN': baseUrl
            },
            body: "{\"itemId\":".concat(itemId, ",\"dataRequested\":\"autoApplyCouponByItemId\"}"),
            mode: 'cors'
          }).then(function (res) {
            return res.ok ? res.json() : Promise.reject(res);
          }).then(function (data) {
            return data;
          })["catch"](function () {
            return;
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCouponData(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/couponServices.js
// module id = 1397
// module chunks = 11